import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, filter, take, tap } from 'rxjs/operators';
import { BANNER_TYPE } from 'src/app/components/banner/banner.constants';
import { environment } from 'src/environments/environment';
import {
  CreatePickupRequest,
  CreatePickupResponse,
  DeletePackageResponse,
} from '../../../models/operations/operations-pickup-stop.model';
import { ErrorhandleService } from '../../error-handling/error-handle/errorhandle.service';
import { DataService } from '../../data/data.service';

@Injectable({
  providedIn: 'root',
})
export class PickupService {
  baseUrl = environment.apiUrl.concat('operations-management');

  constructor(
    private readonly http: HttpClient,
    private readonly errorHandler: ErrorhandleService,
    private readonly dataService: DataService,
  ) {}

  createPickup(
    body: CreatePickupRequest,
    location: string,
    loop: string,
  ): Observable<CreatePickupResponse> {
    return this.http
      .post<CreatePickupResponse>(`${this.baseUrl}/route-pickup/`, body, {
        headers: { location, loop },
      })
      .pipe(
        take(1),
        catchError((error) =>
          this.errorHandler.handleError<CreatePickupResponse>(
            error,
            error.status,
            'Pickup Service: Create Pickup',
            BANNER_TYPE.API_400_ERROR,
            error,
            'pickup',
          ),
        ),
        tap((res) => {
          try {
            if (res?.code === 200) {
              const stopId = res?.response?.stopId ?? null;
              const info = body?.pickupDetail?.infoNotice ?? '';
              if (stopId != null && typeof info === 'string') {
                this.dataService.setInfoNotice(stopId, info);
              }
            }
          } catch {}
        }),
        filter((value) => !!value),
      );
  }

  deletePickup(
    body: CreatePickupRequest,
    location: string,
    loop: string,
  ): Observable<DeletePackageResponse> {
    return this.http
      .post<DeletePackageResponse>(
        `${this.baseUrl}/deletepickuppackage`,
        body,
        {
          headers: {
            location: location,
            loop: loop,
          },
        },
      )
      .pipe(
        take(1),
        catchError((response: HttpErrorResponse) => {
          return this.errorHandler.handleError<DeletePackageResponse>(
            response,
            response.status,
            'Pickup Service: Delete Pickup',
            BANNER_TYPE.API_400_ERROR,
            response as unknown as DeletePackageResponse,
          );
        }),
        filter((value) => !!value),
      );
  }
}
